import { render } from "preact";
import { App } from "./app.tsx";
import "./stil.css";
import { APPVERSION } from "./version.ts";

// b20: appens version, för proven och för den som felsöker.
document.documentElement.dataset.version = APPVERSION;

const rot = document.getElementById("app");
if (rot) render(<App />, rot);

// Appen är en PWA: tjänstearbetaren gör att skalet laddas utan nät.
if ("serviceWorker" in navigator && location.protocol !== "file:") {
  addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
